import { FC, useContext } from "react";
import { useRecoilValue } from "recoil";

import { VirtualizedGrid } from "@ryde/controls";
import {
  BOOKING_CALENDAR_COLUMN_WIDTH,
  BOOKING_CALENDAR_HEADER_ROW_HEIGHT,
  BOOKING_CALENDAR_ROW_HEIGHT,
  datesArrayCalendarBookingsSF,
  daysCountCalendarBookingsSF,
  ScrollAreaEnum,
  visiblePassengersBookingsSelector,
} from "@ryde/shared";

import { BookingCalendarContext } from "../booking-calendar";
import { BookingCalendarCellRenderStrategy } from "./booking-calendar-cell-render-strategy";
import { BookingCalendarWrapperStyled } from "./booking-calendar.styled";

export const BookingCalendarWrapper: FC = () => {
  const days = useRecoilValue(daysCountCalendarBookingsSF);
  const dates = useRecoilValue(datesArrayCalendarBookingsSF);
  const passengers = useRecoilValue(visiblePassengersBookingsSelector);
  const { bookingCalendarWidth, bookingCalendarHeight } = useContext(
    BookingCalendarContext,
  );

  return (
    <BookingCalendarWrapperStyled
      $passengersCount={passengers.length}
      $daysCount={days}
    >
      <VirtualizedGrid
        scrollArea={ScrollAreaEnum.BookingsCalendar}
        height={bookingCalendarHeight}
        width={bookingCalendarWidth}
        frozenRowCount={1}
        frozenColumnCount={1}
        // first row and first column are frozen
        columnCount={dates.length + 1}
        rowCount={passengers.length + 1}
        columnWidth={() => BOOKING_CALENDAR_COLUMN_WIDTH}
        rowHeight={index =>
          index === 0
            ? BOOKING_CALENDAR_HEADER_ROW_HEIGHT
            : BOOKING_CALENDAR_ROW_HEIGHT
        }
        CellRenderer={BookingCalendarCellRenderStrategy}
      />
    </BookingCalendarWrapperStyled>
  );
};
